import type { useAgencyFlow } from './agency-flow.hook'
import { useAgencyFlowDeleteDialog } from './use-agency-flow-delete-dialog.hook'
import { useAgencyFlowEdgePopover } from './use-agency-flow-edge-popover.hook'

export const useAgencyFlowCanvasDialogs = (agencyFlow: ReturnType<typeof useAgencyFlow>) => {
  const deleteDialog = useAgencyFlowDeleteDialog(agencyFlow)
  const edgePopover = useAgencyFlowEdgePopover(agencyFlow)

  return {
    deleteDialogState: deleteDialog.deleteDialogState,
    edgePopoverState: edgePopover.edgePopoverState,
    handleDeleteRequest: deleteDialog.handleDeleteRequest,
    handleDeleteConfirm: deleteDialog.handleDeleteConfirm,
    closeDeleteDialog: deleteDialog.closeDeleteDialog,
    openEdgePopover: edgePopover.openEdgePopover,
    closeEdgePopover: edgePopover.closeEdgePopover,
    handleEdgeLabelSave: edgePopover.handleEdgeLabelSave,
    handleEdgePopoverOpenChange: edgePopover.handleEdgePopoverOpenChange,
  }
}
